// extracted by mini-css-extract-plugin
export var boldText = "_65-4";
export var checkboxContainer = "_65-6";
export var closeIcon = "_65-i";
export var container = "_65-0";
export var drawer = "_65-8";
export var drawerContent = "_65-9";
export var extraSmallText = "_65-5";
export var fulfillmentGroupTable = "_65-e";
export var largeText = "_65-3";
export var loadingSpinnerContainer = "_65-j";
export var mediumText = "_65-2";
export var narrow = "_65-f";
export var notificationLink = "_65-l";
export var packageCheckIconContainer = "_65-7";
export var slideoutHeaderActions = "_65-g";
export var slideoutHeaderActionsShifted = "_65-h";
export var slideoutHeaderContainer = "_65-a";
export var slideoutModal = "_65-c";
export var stickyHeaderWrapper = "_65-b";
export var table = "_65-k";
export var tableContainer = "_65-d";
export var tertiaryText = "_65-1";